let errorMessages = {
  COMMON_ERROR_MESSAGE: 'Something Went Wrong. Please Try After Sometime'
}

export default errorMessages